import { scoreRowCardStyles } from '../ScoreRowCard.styles';
import { SkillLevelTag, TextContent } from '@/components';
import { TScoreSkillLevel } from '@/types';
import { SKILL_LEVELS, WORDS } from '@/constants';
import React from 'react';

/** Props for the ScoreRowCardTitleRowAndSkillTag component */
export interface ScoreRowCardTitleRowAndSkillTagProps {
  /** The category label to display */
  category?: string;
  /** Whether the data is still loading */
  isLoading?: boolean;
  /** Whether to show the skill level tag */
  showSkillLevelTag?: boolean | TScoreSkillLevel;
  /** The skill level to display */
  skillLevel?: TScoreSkillLevel;
}

/**
 * Renders the title row with category and optional skill level tag
 */
export const ScoreRowCardTitleRowAndSkillTag: React.FC<ScoreRowCardTitleRowAndSkillTagProps> = ({
  category,
  isLoading,
  showSkillLevelTag,
  skillLevel,
}) => (
  <div className={scoreRowCardStyles.titleRow}>
    <TextContent
      className={scoreRowCardStyles.category}
      isLoading={isLoading}
      label={isLoading ? WORDS.CATEGORY : category}
      level={3}
      loadingClassName="h-6 w-36"
      type="headline"
    />

    {showSkillLevelTag && (
      <SkillLevelTag
        isLoading={isLoading}
        loadingClassName="h-6 w-20"
        skillLevel={isLoading ? SKILL_LEVELS.BEGINNER : skillLevel}
      />
    )}
  </div>
);

ScoreRowCardTitleRowAndSkillTag.displayName = 'ScoreRowCardTitleRowAndSkillTag';

export default ScoreRowCardTitleRowAndSkillTag;
